export default "__VITE_ASSET__Do1iDIV4__"